<script setup></script>

<template></template>

<style scoped lang="less"></style>
NEW_FILE_CODE
<template>
  <div class="performance-upload-page">
    <!-- 流程步骤 -->
    <div class="step-indicator">
      <div
        class="step-node"
        :class="{
          active: currentFlow === 'employee',
          done: ['deptReview', 'higherReview', 'completed'].includes(
            currentFlow,
          ),
        }"
      >
        <div class="step-circle">1</div>
        <div class="step-label">员工填写 & 选择部门领导</div>
      </div>
      <div class="arrow-symbol">→</div>
      <div
        class="step-node"
        :class="{
          active: currentFlow === 'deptReview',
          done: ['higherReview', 'completed'].includes(currentFlow),
        }"
      >
        <div class="step-circle">2</div>
        <div class="step-label">部门领导审批</div>
      </div>
      <div class="arrow-symbol">→</div>
      <div
        class="step-node"
        :class="{
          active: currentFlow === 'higherReview',
          done: currentFlow === 'completed',
        }"
      >
        <div class="step-circle">3</div>
        <div class="step-label">上级复核</div>
      </div>
      <div style="display: flex; margin-left: auto">
        <div class="status-badge flow-status">{{ flowStatusText }}</div>
        <div
          class="status-badge reward-system"
          @click="$emit('view-reward-system')"
          style="cursor: pointer"
        >
          📋 绩效管理奖惩制度
        </div>
      </div>
    </div>

    <div class="form-card">
      <!-- 基本信息 -->
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">填表日期：</span>
          <span class="info-value">
            <el-date-picker
              v-model="formData.fillDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              disabled
              style="width: 100%"
            />
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">被考核人：</span>
          <span class="info-value">
            <el-input
              v-model="formData.empName"
              placeholder="请输入被考核人姓名"
              disabled
            />
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">部门：</span>
          <span class="info-value">
            <el-select
              v-model="formData.dept"
              placeholder="请选择部门"
              :disabled="!isEmployeeEditing"
              style="width: 100%"
            >
              <el-option
                v-for="leader in departmentList"
                :key="leader.value"
                :label="leader.label"
                :value="leader.value"
              />
            </el-select>
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">岗位：</span>
          <span class="info-value">
            <el-input
              v-model="formData.position"
              placeholder="请输入岗位"
              :disabled="!isEmployeeEditing"
            />
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">考核年度：</span>
          <span class="info-value">
            <el-select
              v-model="formData.year"
              placeholder="请选择考核年度"
              :disabled="!isEmployeeEditing"
              style="width: 100%"
            >
              <el-option
                v-for="item in yearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">考核类型：</span>
          <span class="info-value">
            <el-select
              v-model="formData.kpiType"
              placeholder="请选择考核类型"
              :disabled="!isEmployeeEditing"
              style="width: 100%"
              @change="handleKpiTypeChange"
            >
              <el-option label="年度" value="年度" />
              <el-option label="季度" value="季度" />
              <el-option label="月度" value="月度" />
            </el-select>
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">周期细分：</span>
          <span class="info-value">
            <el-select
              v-model="formData.periodDetail"
              placeholder="请选择周期"
              :disabled="!isEmployeeEditing || !formData.kpiType"
              style="width: 100%"
            >
              <el-option
                v-for="item in periodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </span>
        </div>

        <div class="info-item">
          <span class="info-label">选择部门领导：</span>
          <span class="info-value">
            <el-select
              v-model="formData.deptLeader"
              placeholder="请选择部门领导"
              :disabled="!isEmployeeEditing"
              style="width: 100%"
              @change="handleDeptLeaderChange"
            >
              <el-option
                v-for="leader in deptLeaders"
                :key="leader.value"
                :label="leader.label"
                :value="leader.value"
              />
            </el-select>
          </span>
        </div>
      </div>

      <!-- 提示信息 -->
      <div class="total-info">
        <div>
          <div>
            📌
            员工需完整填写各项指标落实情况，可点击"➕新增考核指标"补充个性化任务项。亮点评分和扣分项由领导在审批环节综合评定。
          </div>
          <div style="margin-top: 10px">
            📌 权重分是由各项指标的权重分➕亮点评分的权重分(权重分总分为100)
          </div>
        </div>
        <div style="display: flex; align-items: center; gap: 12px">
          <span
            :class="[
              'weight-status',
              totalWeightScore === 100 ? 'weight-correct' : 'weight-error',
            ]"
          >
            {{
              totalWeightScore === 100
                ? `✔ 权重分总和: ${totalWeightScore} (正确)`
                : `✖ 权重分总和: ${totalWeightScore} (应为100)`
            }}
          </span>
          <span
            style="
              font-size: 13px;
              background: #daeed2;
              padding: 5px 14px;
              border-radius: 20px;
            "
          >
            ✔ 员工无需自评分数
          </span>
        </div>
      </div>

      <!-- 考核指标表格 -->
      <div class="table-wrapper upload-table">
        <el-table
          :data="indicatorList"
          border
          style="width: 100%"
          :header-cell-style="{
            background: '#eef4e7',
            color: '#1d4d24',
            fontWeight: '600',
          }"
          :cell-style="{ padding: '14px 12px' }"
        >
          <el-table-column label="指标分类" min-width="20%">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.category"
                :disabled="!isEmployeeEditing"
                placeholder="指标分类"
              />
            </template>
          </el-table-column>

          <el-table-column label="考核指标及目标要求" min-width="30%">
            <template slot-scope="scope">
              <el-input
                type="textarea"
                v-model="scope.row.requirement"
                :rows="2"
                :disabled="!isEmployeeEditing"
                placeholder="考核指标及目标要求"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="员工填写：推进落实情况 / 具体事例"
            min-width="38%"
          >
            <template slot-scope="scope">
              <el-input
                type="textarea"
                v-model="scope.row.implementation"
                :rows="2"
                :disabled="!isEmployeeEditing"
                placeholder="请填写推进落实情况"
              />
            </template>
          </el-table-column>

          <el-table-column label="权重分 (参考)" width="220" align="center">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.weight"
                :min="0"
                :max="100"
                :step="1"
                :disabled="!isEmployeeEditing"
                controls-position="right"
                style="width: 100%"
              />
            </template>
          </el-table-column>

          <el-table-column label="" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="deleteIndicator(scope.$index)"
                :disabled="!isEmployeeEditing"
                style="color: #b1594b; font-size: 18px"
              />
            </template>
          </el-table-column>
        </el-table>

        <div
          style="
            display: flex;
            justify-content: flex-end;
            margin: 12px 12px 12px 0;
          "
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addIndicator"
            :disabled="!isEmployeeEditing"
            class="add-row-btn"
          >
            新增考核指标
          </el-button>
        </div>
      </div>

      <!-- 亮点评分与扣分项 -->
      <div class="bonus-deduct-section">
        <div class="bonus-card">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="card-title">
              ✨ 亮点评分（附加分，满分10分）
              <span class="small-hint">由领导评定</span>
            </div>
            <div>
              <span style="color: #1d4d24; font-weight: 600; margin-right: 5px"
                >权重分</span
              >
              <el-input-number
                v-model="bonusWeight"
                :min="10"
                :max="10"
                :step="1"
                :disabled="!isEmployeeEditing"
                controls-position="right"
                style="width: 160px"
              />
            </div>
          </div>

          <div style="margin-top: 14px">
            <label style="font-weight: 500">亮点工作/突出业绩：</label>
            <el-input
              type="textarea"
              v-model="bonusData.highlightDesc"
              :rows="2"
              :disabled="!isEmployeeEditing"
              placeholder="描述亮点及价值贡献"
              style="width: 100%; margin-top: 8px"
            />
            <div class="rule-note" style="margin-top: 8px">
              * 单项工作亮点可累计，最高10分，最终由考核领导打分
            </div>
          </div>
        </div>

        <div class="deduct-card" style="margin-top: 20px">
          <div class="card-title">
            ⚠️ 扣分项（否决项/失误扣分）
            <span class="small-hint">领导根据事实扣减</span>
          </div>
          <div>
            <label style="font-weight: 500">扣分事由说明：</label>
            <el-input
              type="textarea"
              v-model="bonusData.deductReason"
              :rows="2"
              :disabled="!isEmployeeEditing"
              placeholder="如无则留空，若有失误请描述具体事件"
              style="width: 100%; margin-top: 8px"
            />
            <div class="rule-note" style="margin-top: 8px">
              * 按严重程度每次扣0-20分，多个事项累计上限20分
            </div>
          </div>
        </div>
      </div>
      <!-- 员工提交按钮 -->
      <div
        style="
          display: flex;
          justify-content: flex-end;
          gap: 16px;
          margin-top: 28px;
        "
      >
        <el-button
          type="primary"
          size="medium"
          @click="validateAndSubmit"
          :disabled="currentFlow !== 'employee'"
          style="background: #236b3e"
        >
          📬 提交给所选部门领导
        </el-button>
      </div>

      <div
        id="flowMsgNote"
        style="
          font-size: 12px;
          margin-top: 14px;
          color: #617a5c;
          text-align: right;
        "
      >
        *
        支持动态新增考核指标，亮点评分及扣分项分开独立填写，员工提交后由领导评价。
      </div>

      <footer>
        流程：员工填写（可新增指标+亮点/扣分描述）→ 选择部门领导提交 →
        部门领导评分/评语 → 上级复核确认
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerformanceUpload',
  props: {
    currentFlow: {
      type: String,
      required: true,
    },
    isEmployeeEditing: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    departmentList: {
      type: Array,
      required: true,
    },
    deptLeaders: {
      type: Array,
      required: true,
    },
    yearOptions: {
      type: Array,
      required: true,
    },
    periodOptions: {
      type: Array,
      required: true,
    },
    indicatorList: {
      type: Array,
      required: true,
    },
    bonusWeight: {
      type: Number,
      required: true,
    },
    bonusData: {
      type: Object,
      required: true,
    },
    approvalData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    flowStatusText() {
      const statusMap = {
        employee: '待员工提交',
        deptReview: '📌 部门领导审批中',
        higherReview: '⭐ 上级复核阶段',
        completed: '✅ 流程结束',
      };
      return statusMap[this.currentFlow] || '待员工提交';
    },
    // 计算总权重分
    totalWeightScore() {
      const indicatorWeight = this.indicatorList.reduce(
        (sum, item) => sum + (Number(item.weight) || 0),
        0,
      );
      const bonusWeightValue = Number(this.bonusWeight) || 0;
      return indicatorWeight + bonusWeightValue;
    },
  },
  methods: {
    handleKpiTypeChange(value) {
      this.$emit('kpi-type-change', value);
    },
    addIndicator() {
      this.$emit('add-indicator');
    },
    deleteIndicator(index) {
      this.$emit('delete-indicator', index);
    },
    handleDeptLeaderChange(val) {
      this.deptLeaders.map((item) => {
        if (val === item.value) {
          this.formData.selectedDeptLeaderName = item.label;
        }
      });
    },
    // 验证并提交数据
    validateAndSubmit() {
      // 1. 收集所有数据
      const submitData = {
        formData: this.formData,
        indicatorList: this.indicatorList,
        bonusData: {
          highlightDesc: this.bonusData.highlightDesc,
          deductReason: this.bonusData.deductReason,
          bonusWeight: this.bonusWeight,
        },
        totalWeightScore: this.totalWeightScore,
      };

      console.log('=== 提交的完整数据 ===');
      console.log('基本信息:', submitData.formData);
      console.log('考核指标列表:', submitData.indicatorList);
      console.log('亮点评分与扣分项:', submitData.bonusData);
      console.log('总权重分:', submitData.totalWeightScore);

      // 2. 验证必填字段
      if (!this.formData.dept) {
        this.$message.warning('请选择部门');
        return false;
      }

      if (!this.formData.position) {
        this.$message.warning('请输入岗位');
        return false;
      }

      if (!this.formData.year) {
        this.$message.warning('请选择考核年度');
        return false;
      }

      if (!this.formData.kpiType) {
        this.$message.warning('请选择考核类型');
        return false;
      }

      if (!this.formData.periodDetail) {
        this.$message.warning('请选择周期细分');
        return false;
      }

      if (!this.formData.deptLeader) {
        this.$message.warning('请选择部门领导');
        return false;
      }

      // 3. 验证至少有一项考核指标
      if (!this.indicatorList || this.indicatorList.length === 0) {
        this.$message.warning('请至少添加一项考核指标');
        return false;
      }

      // 4. 验证每项考核指标的必填内容
      const emptyIndicator = this.indicatorList.find(
        (item, index) =>
          !item.category || !item.requirement || !item.implementation,
      );

      if (emptyIndicator) {
        const index = this.indicatorList.indexOf(emptyIndicator) + 1;
        this.$message.warning(`请填写第 ${index} 项考核指标的完整信息`);
        return false;
      }

      // 5. 验证每项考核指标的权重分
      const invalidWeight = this.indicatorList.find(
        (item) => !item.weight || item.weight <= 0,
      );

      if (invalidWeight) {
        this.$message.warning('每项考核指标的权重分必须大于0');
        return false;
      }

      // 6. 验证总权重分是否等于100
      const totalScore = this.totalWeightScore;

      if (totalScore !== 100) {
        const diff = Math.abs(totalScore - 100);
        let message = '';

        if (totalScore > 100) {
          message =
            `⚠️ 权重分总和为 ${totalScore} 分，超出 ${diff} 分！\n\n` +
            `各项考核指标权重分之和（${this.indicatorList.reduce((sum, item) => sum + (Number(item.weight) || 0), 0)} 分）` +
            ` + 亮点评分权重分（${this.bonusWeight} 分）= ${totalScore} 分\n\n` +
            `请调整各项权重分，确保总和等于 100 分`;
        } else {
          message =
            `⚠️ 权重分总和为 ${totalScore} 分，还差 ${diff} 分！\n\n` +
            `各项考核指标权重分之和（${this.indicatorList.reduce((sum, item) => sum + (Number(item.weight) || 0), 0)} 分）` +
            ` + 亮点评分权重分（${this.bonusWeight} 分）= ${totalScore} 分\n\n` +
            `请调整各项权重分，确保总和等于 100 分`;
        }

        this.$alert(message, '权重分验证失败', {
          confirmButtonText: '知道了',
          type: 'warning',
          dangerouslyUseHTMLString: false,
        });

        return false;
      }

      let newData = {
        companyId: JSON.parse(localStorage.getItem('ordinaryUser'))?.userDetail
          ?.companyInfo?.companyId,
        departmentId: submitData.formData.dept,
        userId: JSON.parse(localStorage.getItem('ordinaryUser'))?.userDetail
          ?.userId,
        userName: JSON.parse(localStorage.getItem('ordinaryUser'))?.userDetail
          ?.username,
        positionName: submitData.formData.position,
        assessmentYear: submitData.formData.year,
        assessmentType: submitData.formData.kpiType,
        periodDetail: submitData.formData.periodDetail,
        fillDate: submitData.formData.fillDate,
        selectedDeptLeaderUserId: submitData.formData.deptLeader,
        selectedDeptLeaderName: submitData.formData.selectedDeptLeaderName,
        employeeHighlightDesc: submitData.bonusData.highlightDesc,
        employeeDeductDesc: submitData.bonusData.deductReason,
        employeeHighlightScore: submitData.bonusData.bonusWeight,
        totalWeightScore: this.totalWeightScore,
        items: [],
      };
      submitData.indicatorList.map((item) => {
        newData.items.push({
          itemType: 'custom',
          indicatorType: item.category,
          targetRequirement: item.requirement,
          employeeResult: item.implementation,
          weightScore: item.weight,
        });
      });
      // 7. 所有验证通过，发出提交事件
      this.$emit('employee-submit', newData);
      return true;
    },
  },
};
</script>

<style scoped lang="less">
.performance-upload-page {
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.step-indicator {
  background: #f8faf4;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  border-bottom: 1px solid #dee6da;
  font-size: 14px;

  .step-node {
    display: flex;
    align-items: center;
    gap: 10px;

    .step-circle {
      width: 32px;
      height: 32px;
      background: #cfdec8;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #2f5434;
    }

    &.active .step-circle {
      background: #2b6e3c;
      color: white;
      box-shadow: 0 0 0 3px rgba(43, 110, 60, 0.2);
    }

    &.done .step-circle {
      background: #5c8f60;
      color: white;
    }

    .step-label {
      font-weight: 500;
    }

    &.active .step-label {
      color: #1d6b38;
      font-weight: 700;
    }
  }

  .arrow-symbol {
    color: #9bb894;
    font-size: 20px;
  }

  .status-badge {
    margin-left: auto;
    background: #e8f0e3;
    padding: 6px 18px;
    border-radius: 40px;
    font-size: 13px;
    font-weight: 500;

    &.reward-system {
      margin-left: 12px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #d4e4cd;
        transform: translateY(-1px);
      }
    }
  }
}

.form-card {
  padding: 28px 32px 32px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px 28px;
  background: #fafef7;
  padding: 20px 24px;
  border-radius: 24px;
  margin-bottom: 28px;
  border: 1px solid #e2edda;

  .info-item {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    font-size: 14px;

    .info-label {
      width: 100px;
      font-weight: 600;
      color: #2b5a2f;
    }

    .info-value {
      flex: 1;
      color: #1a3220;
      font-weight: 500;
    }
  }
}

.upload-table {
  overflow-x: auto;
  margin: 24px 0 20px;
  border-radius: 20px;
  border: 1px solid #e2edd9;

  /deep/ .el-table {
    border-radius: 20px;
    overflow: hidden;

    th {
      background: #eef4e7 !important;
      color: #1d4d24;
      font-weight: 600;
      padding: 14px 12px;
      border-bottom: 1px solid #d3e2cf;
      text-align: center;
    }

    td {
      padding: 14px 12px;
      border-bottom: 1px solid #ecf3e8;
      background-color: white;
    }

    .el-input__inner,
    .el-textarea__inner {
      border: 1px solid #caddd2;
      border-radius: 12px;

      &:focus {
        border-color: #2b823c;
        box-shadow: 0 0 0 3px rgba(43, 130, 60, 0.1);
      }
    }

    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner {
      background-color: #fafef7;
      border-color: #e2edda;
      color: #1a3220;
    }
  }
}

.add-row-btn {
  background: #edf4e8;
  border: 1px dashed #8bb57c;
  border-radius: 28px;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #2b6838;
  transition: 0.2s;

  &:hover {
    background: #e0ecda;
    border-color: #55994a;
  }
}

.bonus-deduct-section {
  margin: 20px 0;

  .bonus-card {
    flex: 1;
    background: #fffaf0;
    border-radius: 20px;
    border: 1px solid #ffe6c2;
    padding: 18px 22px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  }

  .deduct-card {
    flex: 1;
    background: #fef7f5;
    border-radius: 20px;
    border: 1px solid #ffdbd0;
    padding: 18px 22px;
  }

  .card-title {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 14px;
  }

  .bonus-card .card-title {
    color: #b87c2e;
  }

  .deduct-card .card-title {
    color: #bc6f4b;
  }

  .small-hint {
    font-size: 12px;
    color: #8b7a64;
    margin-left: 8px;
  }

  .rule-note {
    font-size: 11px;
    color: #5c7558;
    margin-top: 5px;
    line-height: 1.3;
  }
}

.total-info {
  background: #eef3e9;
  border-radius: 20px;
  padding: 14px 24px;
  margin: 16px 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  .weight-status {
    font-size: 13px;
    padding: 5px 14px;
    border-radius: 20px;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .weight-correct {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }

  .weight-error {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    animation: pulse 2s infinite;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.approval-cards {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .approval-item {
    background: #fefef9;
    border-radius: 20px;
    border: 1px solid #e0ecd9;
    padding: 16px 22px;

    .approval-title {
      width: 130px;
      font-weight: 700;
      color: #2c6736;
      margin-bottom: 20px;
    }
  }
}

footer {
  text-align: center;
  font-size: 12px;
  color: #6a7b64;
  padding: 20px;
  border-top: 1px solid #e2ede0;
  margin-top: 20px;
}
</style>
